import React from 'react';
import { Boxes, BarCode, TrendingUp, AlertTriangle } from 'lucide-react';

const InventoryManagement = () => {
  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-20 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-4">
            <Boxes className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400 text-sm font-semibold uppercase tracking-wider">
              Smart Stock & Warehouse Software
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            Automated Multi-Channel <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-cyan-400 bg-clip-text text-transparent">Inventory Systems</span>
          </h1>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed">
            Eliminate stockouts and overstocking with real-time SKU tracking, barcode scanning, auto-reordering, and warehouse management.
          </p>
        </div>
      </section>

      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <Boxes className="w-10 h-10 text-cyan-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Multi-Warehouse Tracking</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Real-time inventory levels across multiple fulfillment centers, stores, and warehouses.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <TrendingUp className="w-10 h-10 text-orange-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Demand Forecasting</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">AI-driven reorder point predictions, seasonal demand trends, and supplier lead time analysis.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <AlertTriangle className="w-10 h-10 text-amber-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Low-Stock Alerts & POs</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Automated purchase order generation, vendor management, and instant stock threshold alerts.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InventoryManagement;
